import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.string.replace.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "auto-setting"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "form"
};
const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "自动结算开关", -1);

const _hoisted_6 = {
  class: "wrapper"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "settle-tips"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "red"
}, "自动结算仅支持线上支付订单。"), /*#__PURE__*/_createElementVNode("p", null, "将线上支付订单金额按分账规则进行系统自动结算，各方收到结算款后可进行提现。")], -1);

const _hoisted_8 = {
  class: "wrapper"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "平台服务费承担方", -1);

const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  class: "tips"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "平台服务费：", -1);

const _hoisted_13 = {
  class: "red"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "结算时扣减承担方分账金额，若承担方分账金额不足以抵扣服务费系统将随机向其他可满足角色收取。", -1);

const _hoisted_15 = /*#__PURE__*/_createTextVNode("新增承担方");

const _hoisted_16 = {
  key: 0
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_18 = {
  class: "wrapper"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "业务员提现设置", -1);

const _hoisted_20 = {
  class: "content"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode("支持");

const _hoisted_22 = /*#__PURE__*/_createTextVNode("不支持");

const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"tips\"><p><span>支持：</span><span>业务员分账金额</span><span class=\"red\">由平台代收</span><span>，业务员申请提现</span><span class=\"red\">团队审核后由平台打款至业务员账户。</span></p><p><span>不支持：</span><span>业务员分账金额</span><span class=\"red\">打款至销售团队账户</span><span>，若销售团队无账户，打款至平台代收，</span><span class=\"red\">线下结算。</span></p></div>", 1);

const _hoisted_24 = {
  class: "card"
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "提现时间"), /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "指定时间开放提现申请入口")], -1);

const _hoisted_26 = {
  class: "withdraw-select"
};
const _hoisted_27 = {
  class: "select-wrapper"
};

const _hoisted_28 = /*#__PURE__*/_createTextVNode("任意时间");

const _hoisted_29 = {
  class: "select-wrapper"
};

const _hoisted_30 = /*#__PURE__*/_createTextVNode("每周固定时间提现");

const _hoisted_31 = {
  class: "select-wrapper"
};

const _hoisted_32 = /*#__PURE__*/_createTextVNode("每月固定时间提现");

const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin": "0 10px"
  }
}, "~", -1);

const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "提现金额范围"), /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "按业务员下单时间计算")], -1);

const _hoisted_35 = /*#__PURE__*/_createTextVNode("全部分账金额");

const _hoisted_36 = /*#__PURE__*/_createTextVNode("上周分账金额（包含上周之前时间）");

const _hoisted_37 = /*#__PURE__*/_createTextVNode("上月分账金额（包含上月之前时间）");

const _hoisted_38 = {
  class: "card-header"
};

const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "提现审核", -1);

const _hoisted_40 = {
  class: "info"
};

const _hoisted_41 = /*#__PURE__*/_createTextVNode("审核");

const _hoisted_42 = /*#__PURE__*/_createTextVNode("无需审核");

const _hoisted_43 = {
  class: "card-header"
};

const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "设置审核人", -1);

const _hoisted_45 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "任一审核人通过后可打款至业务员账户", -1);

const _hoisted_47 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_48 = {
  class: "card-header"
};

const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "设置免审人", -1);

const _hoisted_50 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "免审用户无需审核", -1);

const _hoisted_52 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_53 = {
  class: "wrapper",
  style: {
    "margin-top": "20px"
  }
};

const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, null, -1);

const _hoisted_55 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_56 = /*#__PURE__*/_createTextVNode("确定");

import { reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { cloneDeep, get } from 'lodash-es';
import { getSalesmanListBySupplierId, getUserInfoByStructureId } from '@/request';
import Axios from '@/request/createAxiosInstalce';
import UserModal from './components/supplier-user-modal.vue';
export default {
  name: 'auto-setting',

  setup(__props) {
    onMounted(() => {
      getDetail(); // getRuleValue()
    });
    const route = useRoute();
    const router = useRouter();
    const formTpl = {
      autoSettlement: 0,
      serviceFeeBearers: [{
        bearerType: 6,
        serviceFeeRate: 2
      }],
      withdrawalSwitch: 1,
      withdrawalTimeType: 0,
      weeklyWithdrawalTime: '',
      monthlyWithdrawalTimeStart: '',
      monthlyWithdrawalTimeEnd: '',
      withdrawalAmountRange: 0,
      requiresReview: 1,
      reviewUsers: [],
      noReviewUsers: [],
      serviceFeeRate: undefined
    };
    const form = ref(_objectSpread({}, formTpl));
    const dateRange = ref([]);
    const ruleValue = ref(0);

    function getRuleValue() {
      Axios.get('/admin/split/rule/getPlatformServiceFee.json').then(res => {
        let {
          success,
          data
        } = res.data;

        if (success) {
          let value = (parseFloat(data.dictitemCode) * 100).toFixed(2);
          ruleValue.value = value;
        }
      });
    }

    function getDetail() {
      let params = {
        supplierId: route.query.supplierId
      };
      Axios.get('/admin/split/autoSettlement/view.json', {
        params
      }).then(res => {
        let {
          success,
          data
        } = res.data;

        if (!success) {
          getManList();
        }

        let body = {};
        Object.keys(form.value).forEach(key => {
          let value = data[key] == null ? form.value[key] : data[key];
          body[key] = value;
        });
        body.reviewUsers = data.reviewUsers || [];
        body.noReviewUsers = data.noReviewUsers || [];
        body.serviceFeeBearers.forEach(item => {
          item.serviceFeeRate = item.serviceFeeRate * 100;
        }); // console.log(body)

        if (typeof body.weeklyWithdrawalTime === 'string') {
          body.weeklyWithdrawalTime = get(body, 'weeklyWithdrawalTime', '').split(',').filter(Boolean);
        }

        let monthlyWithdrawalTime = data.monthlyWithdrawalTime || '';
        let monthTimeList = monthlyWithdrawalTime.split(',').filter(Boolean);
        body.monthlyWithdrawalTimeStart = parseInt(monthTimeList[0]) || '';
        body.monthlyWithdrawalTimeEnd = parseInt(monthTimeList[1]) || '';
        body.serviceFeeRate = (parseFloat(body.serviceFeeRate) * 100).toFixed(2);
        form.value = body;

        if (body.reviewUsers.length == 0) {
          getManList();
        }
      });
    }

    function getManList() {
      let params = {
        supplierId: route.query.supplierId,
        structureId: route.query.supplierId,
        levelType: 0
      };
      getUserInfoByStructureId(params).then(res => {
        form.value.reviewUsers = res.rows.filter(v => v.employeeType == 1).map(v => {
          return {
            linkMan: v.linkMan,
            supUserId: v.supUserId
          };
        });
      });
    }

    function submit() {
      let {
        withdrawalTimeType,
        monthlyWithdrawalTimeStart,
        monthlyWithdrawalTimeEnd,
        serviceFeeBearers = [],
        serviceFeeRate
      } = form.value;

      if (withdrawalTimeType == 2 && monthlyWithdrawalTimeStart > monthlyWithdrawalTimeEnd) {
        ElMessage.error('每月固定提现时间不正确');
        return;
      }

      let bearerTypes = Array.from(new Set(serviceFeeBearers.map(v => v.bearerType)));

      if (bearerTypes.length !== serviceFeeBearers.length) {
        ElMessage.error('服务费承担方存在相同项');
        return;
      }

      let serviceFeeRateList = serviceFeeBearers.map(v => v.serviceFeeRate).filter(Boolean);
      let sumValue = serviceFeeRateList.reduce((pre, cur) => pre + cur, 0).toFixed(2);

      if (sumValue != serviceFeeRate) {
        ElMessage.error('承担方费率总和不等于平台服务费率');
        return;
      }

      let body = cloneDeep(form.value);
      body.serviceFeeBearers.forEach(item => {
        item.serviceFeeRate = item.serviceFeeRate / 100;
      });
      body.serviceFeeRate = serviceFeeRate / 100;
      body.supplierId = route.query.supplierId;

      if (body.withdrawalTimeType == 0) {
        delete body.weeklyWithdrawalTime;
      } else if (body.withdrawalTimeType == 1) {
        if (body.weeklyWithdrawalTime.length == 0) {
          ElMessage.error('请填写每周固定时间');
          return;
        }

        body.weeklyWithdrawalTime = body.weeklyWithdrawalTime.join();
      } else if (body.withdrawalTimeType == 2) {
        if (!body.monthlyWithdrawalTimeStart || !body.monthlyWithdrawalTimeEnd) {
          ElMessage.error('请填写每月固定时间');
          return;
        }

        body.monthlyWithdrawalTime = `${body.monthlyWithdrawalTimeStart},${body.monthlyWithdrawalTimeEnd}`;
        delete body.weeklyWithdrawalTime;
      }

      if (body.requiresReview == 1 && body.reviewUsers.length == 0) {
        ElMessage.error('请选择审核人');
        return;
      }

      delete body.monthlyWithdrawalTimeStart;
      delete body.monthlyWithdrawalTimeEnd;
      Axios.post('/admin/split/autoSettlement/save.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          router.replace({
            name: 'sepaccountRule'
          });
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function bearerTypeChange(row, v) {
      let params = {
        supplierId: route.query.supplierId,
        bearerType: v
      };
      Axios.get('/admin/split/autoSettlement/checkSupplierBearerType.json', {
        params
      }).then(res => {
        let {
          checkResult
        } = res.data.data;

        if (checkResult) {
          row.bearerType = v;
        } else {
          ElMessage.error('该团队分账规则中不存在此承担方角色，请确认');
        }
      });
    }

    const userModal = reactive({
      show: false,
      type: 'audit'
    });

    function userAction(type) {
      userModal.show = true;
      userModal.type = type;
    }

    function getUserHandle(list) {
      if (userModal.type === 'audit') {
        form.value.reviewUsers = list;
      } else {
        form.value.noReviewUsers = list;
      }
    }

    function deletePerson(list, index) {
      ElMessageBox.confirm('确认删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        list.splice(index, 1);
      });
    }

    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(route).query.supplierName), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_switch, {
        modelValue: form.value.autoSettlement,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.autoSettlement = $event),
        "active-value": 1,
        "inactive-value": 0
      }, null, 8, ["modelValue"]), _hoisted_7])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", _hoisted_13, _toDisplayString(form.value.serviceFeeRate) + "%", 1), _hoisted_14]), _createVNode(_component_el_button, {
        type: "primary",
        style: {
          "margin": "10px 0"
        },
        onClick: _cache[1] || (_cache[1] = $event => form.value.serviceFeeBearers.push({
          bearerType: 6,
          serviceFeeRate: undefined
        }))
      }, {
        default: _withCtx(() => [_hoisted_15]),
        _: 1
      }), _createVNode(_component_el_table, {
        data: form.value.serviceFeeBearers
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "承担方"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_select, {
            "model-value": scope.row.bearerType,
            onChange: v => {
              bearerTypeChange(scope.row, v);
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              value: 1,
              label: "商业公司"
            }), _createVNode(_component_el_option, {
              value: 2,
              label: "销售团队主体"
            }), _createVNode(_component_el_option, {
              value: 3,
              label: "一级团队分账受益人"
            }), _createVNode(_component_el_option, {
              value: 4,
              label: "二级团队分账受益人"
            }), _createVNode(_component_el_option, {
              value: 5,
              label: "三级团队分账受益人"
            }), _createVNode(_component_el_option, {
              value: 6,
              label: "业务员"
            })]),
            _: 2
          }, 1032, ["model-value", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "服务费（%）"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input_number, {
            modelValue: scope.row.serviceFeeRate,
            "onUpdate:modelValue": $event => scope.row.serviceFeeRate = $event,
            min: 0,
            max: 100,
            precision: 2,
            "controls-position": "right"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [scope.$index == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "-")) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "danger",
            size: "small",
            onClick: $event => form.value.serviceFeeBearers.splice(scope.$index, 1)
          }, {
            default: _withCtx(() => [_hoisted_17]),
            _: 2
          }, 1032, ["onClick"]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_radio_group, {
        modelValue: form.value.withdrawalSwitch,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.withdrawalSwitch = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 0
        }, {
          default: _withCtx(() => [_hoisted_22]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _hoisted_23, _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_radio, {
        modelValue: form.value.withdrawalTimeType,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.withdrawalTimeType = $event),
        label: 0
      }, {
        default: _withCtx(() => [_hoisted_28]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_radio, {
        modelValue: form.value.withdrawalTimeType,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.withdrawalTimeType = $event),
        label: 1
      }, {
        default: _withCtx(() => [_hoisted_30]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: form.value.weeklyWithdrawalTime,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.weeklyWithdrawalTime = $event),
        placeholder: "请选择",
        style: {
          "width": "300px"
        },
        multiple: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          value: "7",
          label: "周日"
        }), _createVNode(_component_el_option, {
          value: "1",
          label: "周一"
        }), _createVNode(_component_el_option, {
          value: "2",
          label: "周二"
        }), _createVNode(_component_el_option, {
          value: "3",
          label: "周三"
        }), _createVNode(_component_el_option, {
          value: "4",
          label: "周四"
        }), _createVNode(_component_el_option, {
          value: "5",
          label: "周五"
        }), _createVNode(_component_el_option, {
          value: "6",
          label: "周六"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_el_radio, {
        modelValue: form.value.withdrawalTimeType,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.withdrawalTimeType = $event),
        label: 2
      }, {
        default: _withCtx(() => [_hoisted_32]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: form.value.monthlyWithdrawalTimeStart,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.monthlyWithdrawalTimeStart = $event),
        style: {
          "width": "100px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, i => {
          return _createVNode(_component_el_option, {
            label: i,
            value: i,
            key: i
          }, null, 8, ["label", "value"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"]), _hoisted_33, _createVNode(_component_el_select, {
        modelValue: form.value.monthlyWithdrawalTimeEnd,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.monthlyWithdrawalTimeEnd = $event),
        style: {
          "width": "100px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, i => {
          return _createVNode(_component_el_option, {
            label: i,
            value: i,
            key: i
          }, null, 8, ["label", "value"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])])]), _hoisted_34, _createVNode(_component_el_radio_group, {
        modelValue: form.value.withdrawalAmountRange,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.withdrawalAmountRange = $event),
        class: "group-wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 0
        }, {
          default: _withCtx(() => [_hoisted_35]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_36]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 2
        }, {
          default: _withCtx(() => [_hoisted_37]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("span", _hoisted_40, [_createVNode(_component_el_radio_group, {
        modelValue: form.value.requiresReview,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.requiresReview = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_41]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 0
        }, {
          default: _withCtx(() => [_hoisted_42]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_43, [_hoisted_44, _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _cache[11] || (_cache[11] = $event => userAction('audit'))
      }, {
        default: _withCtx(() => [_hoisted_45]),
        _: 1
      }), _hoisted_46]), _createVNode(_component_el_table, {
        data: form.value.reviewUsers,
        size: "small",
        style: {
          "margin-bottom": "10px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "审核人",
          prop: "linkMan"
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "danger",
            size: "small",
            onClick: $event => deletePerson(form.value.reviewUsers, scope.$index)
          }, {
            default: _withCtx(() => [_hoisted_47]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _cache[12] || (_cache[12] = $event => userAction('noaudit'))
      }, {
        default: _withCtx(() => [_hoisted_50]),
        _: 1
      }), _hoisted_51]), _createVNode(_component_el_table, {
        data: form.value.noReviewUsers,
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "审核人",
          prop: "linkMan"
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "danger",
            size: "small",
            onClick: $event => deletePerson(form.value.noReviewUsers, scope.$index)
          }, {
            default: _withCtx(() => [_hoisted_52]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])]), _createElementVNode("div", _hoisted_53, [_hoisted_54, _createVNode(_component_el_button, {
        onClick: _cache[13] || (_cache[13] = $event => _unref(router).replace({
          name: 'sepaccountRule'
        }))
      }, {
        default: _withCtx(() => [_hoisted_55]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit
      }, {
        default: _withCtx(() => [_hoisted_56]),
        _: 1
      })])]), _createVNode(UserModal, {
        modelValue: userModal.show,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => userModal.show = $event),
        selectedList: userModal.type === 'audit' ? form.value.reviewUsers : form.value.noReviewUsers,
        onSuccess: getUserHandle
      }, null, 8, ["modelValue", "selectedList"])]);
    };
  }

};